<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-06 15:57 -->
<!-- Description:  -->
<template>
  <div>
    <h4>VENDER PRODUCTOS</h4>
    <div class="row">
      <div class="col">
        <StoreSaleForm ref="elStoreSaleForm" v-if="hasStoreSelected" 
          :content="defaultContent"></StoreSaleForm>
        <div v-else class="alert alert-info">
          Antes de registrar ventas requieres seleccionar tu almacen
           en configuración de perfil.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StoreSaleForm from "./StoreSaleForm.vue";

// script content
export default {
  name: "StoreSaleView",
  components: {
    StoreSaleForm,
  },

  // directives

  props: {
    //
  },

  data: () => ({
    defaultContent: {},
    hasStoreSelected: false,
  }),

  computed: {
    //
  },

  // watch: {},

  created() {
    this.hasStoreSelected = !!this.$store.state.user.store.id;
    this.defaultContent.store_id = this.$store.state.user.store.id;
  },

  methods: {
    //
    //
    //
  }
};
</script>
<style scoped></style>

